import Journeys from '@/pages/journeys';
import { sampleWorkspaceRedirect } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/sample-workspace/')({
  beforeLoad: sampleWorkspaceRedirect,
  component: Journeys,
});
